var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container my-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 my-5"},[_c('error-404'),_vm._v(" "),_c('div',{staticClass:"text-center mt-3"},[_c('router-link',{staticClass:"btn btn-primary px-5",attrs:{"to":"/"}},[_vm._v("\n                    Home\n                ")])],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0d6b668","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/NotFound.vue
// module id = null
// module chunks = 